import './index.css'

import React, { Component } from 'react'

import TextInput from '../../../components/text-input'
import PeriodPickerComponent from '../../../components/period-picker'
import TextEditor from '../../../components/text-editor'
import AIImproveButton from '../../../components/ai-improve-button/AIImproveButton'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronUp, faChevronDown, faTrash } from '@fortawesome/free-solid-svg-icons'
import ListLevelHeader from '../../../components/utils/list-element-header'

class EducationComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      model: this.props.model,
      showBody: false,
      editorKey: 0,
    }
  }

  toggleBody = () => {
    let showBody = !this.state.showBody

    this.setState({ showBody })
  }

  update = (field, value) => {
    let model = this.state.model
    model[field] = value
    this.setState({ model })
    this.props.update(this.props.index, model)
  }

  acceptAI = (field, value) => {
    let model = this.state.model
    model[field] = value
    this.setState({ model, editorKey: this.state.editorKey + 1 })
    this.props.update(this.props.index, model, true)
  }

  removeElement = () => {
    if (window.confirm('Are you sure you wish to delete this item?')) {
      this.props.removeElement(this.props.index)
    }
  }

  showArrow = () => {
    let showArrow = <FontAwesomeIcon icon={faChevronDown} />
    if (this.state.showBody) showArrow = <FontAwesomeIcon icon={faChevronUp} />

    return showArrow
  }

  render() {
    return (
      <React.Fragment>
        <div className="education-container">
          <div className="education-header" onClick={this.toggleBody}>
            <ListLevelHeader
              what={this.state.model.degree}
              where={this.state.model.institution}
              period={this.state.model.period}
            />

            <div className="education-header-title education-header-arrow">{this.showArrow()}</div>
          </div>
          <div className={`education-body ${this.state.showBody ? 'open' : 'closed'}`}>
            <div className="section-basics-line">
              <TextInput
                field="degree"
                label="Degree"
                value={this.state.model.degree}
                update={this.update}
              />

              <TextInput
                field="institution"
                label="School"
                value={this.state.model.institution}
                update={this.update}
              />
            </div>
            <div className="section-basics-line">
              <PeriodPickerComponent
                field="period"
                model={this.state.model.period}
                updatePeriod={this.update}
              />

              <TextInput
                field="location"
                label="City"
                value={this.state.model.location}
                update={this.update}
              />
            </div>
            <div>
              <TextEditor
                key={this.state.editorKey}
                field="description"
                label="Description"
                value={this.state.model.description}
                update={this.update}
              />
            </div>
            <div className="ai-improve-row">
              <AIImproveButton
                value={this.state.model.description}
                section="education"
                onAccept={(improved) => this.acceptAI('description', improved)}
              />
              <div className="button-remove-element" onClick={this.removeElement}>
                <FontAwesomeIcon icon={faTrash} />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

EducationComponent.defaultProperties = { open: false }
export default EducationComponent
